var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "environments" }, [
    _c("ul", [
      _c("li", { staticClass: "environments-left tc pr20" }, [
        _c("img", {
          staticClass: "mb10 data-img",
          attrs: {
            src: _vm.userCommonImageUrlForPc + "/company_data_pc.png",
            alt: "environments",
            "data-test": "environments-img",
          },
        }),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "fs11", attrs: { "data-test": "update-date" } },
          [_vm._v(_vm._s(_vm._f("formatDate")(_vm.updateDate)) + "時点")]
        ),
      ]),
      _vm._v(" "),
      _c(
        "li",
        { staticClass: "environments-right pl25" },
        [_vm._t("default")],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "fs15 fwB" }, [
      _vm._v("\n        データで見る"),
      _c("br"),
      _vm._v("働く環境\n      "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }